import mood5Icon from "@assets/mood/grinning-face-with-smiling-eyes.png";
import mood3Icon from "@assets/mood/neutral-face.png";
import mood2Icon from "@assets/mood/sad-but-relieved-face.png";
import mood6Icon from "@assets/mood/smiling-face-with-sunglasses.png";
import mood4Icon from "@assets/mood/smiling-face.png";
import mood1Icon from "@assets/mood/tired-face.png";
import { useI18n } from "@core/i18n/i18n";
import { Exertion, Mood } from "@domain/progress/patient-feedback";
import styled from "@emotion/styled";
import React, { useCallback } from "react";

interface UseFormatFeedbackHook {
	formatExertion: (exertion: Exertion) => { value: string; title: string; description: string };
	formatMood: (mood: Mood) => { title: string; icon: JSX.Element };
}

export const useFormatFeedback = (): UseFormatFeedbackHook => {
	const { format } = useI18n();

	const formatExertion = useCallback(
		(exertion: Exertion) => {
			switch (exertion) {
				case 1:
					return {
						value: format("global.exertion.1.value"),
						title: format("global.exertion.1.title"),
						description: format("global.exertion.1.description"),
					};
				case 2:
					return {
						value: format("global.exertion.2.value"),
						title: format("global.exertion.2.title"),
						description: format("global.exertion.2.description"),
					};
				case 3:
					return {
						value: format("global.exertion.3.value"),
						title: format("global.exertion.3.title"),
						description: format("global.exertion.3.description"),
					};
				case 4:
					return {
						value: format("global.exertion.4.value"),
						title: format("global.exertion.4.title"),
						description: format("global.exertion.4.description"),
					};
				case 5:
					return {
						value: format("global.exertion.5.value"),
						title: format("global.exertion.5.title"),
						description: format("global.exertion.5.description"),
					};

				default:
					return {
						value: format("global.exertion.6.value"),
						title: format("global.exertion.6.title"),
						description: format("global.exertion.6.description"),
					};
			}
		},
		[format],
	);

	const formatMood = useCallback(
		(mood: Mood) => {
			switch (mood) {
				case Mood.VERY_BAD:
					return {
						title: format("global.mood.1.title"),
						icon: <MoodImage src={mood1Icon} />,
					};
				case Mood.BAD:
					return {
						title: format("global.mood.2.title"),
						icon: <MoodImage src={mood2Icon} />,
					};
				case Mood.OK:
					return {
						title: format("global.mood.3.title"),
						icon: <MoodImage src={mood3Icon} />,
					};
				case Mood.GOOD:
					return {
						title: format("global.mood.4.title"),
						icon: <MoodImage src={mood4Icon} />,
					};
				case Mood.VERY_GOOD:
					return {
						title: format("global.mood.5.title"),
						icon: <MoodImage src={mood5Icon} />,
					};
				default:
					return {
						title: format("global.mood.6.title"),
						icon: <MoodImage src={mood6Icon} />,
					};
			}
		},
		[format],
	);

	return {
		formatExertion,
		formatMood,
	};
};

const MoodImage = styled.img`
	width: 16px;
	height: 16px;
`;
